<template>
  <div class="new-route-form">
    <h2 class="form-title">Создание расчета</h2>
    <form @submit.prevent="submitForm" class="form-container">
      <div v-for="field in fields" :key="field.model" class="form-group">
        <label class="form-label">{{ field.label }}</label>
        <input
          v-model="form[field.model]"
          :type="field.type"
          step="1000"
          min="0"
          class="form-input"
          :required="field.required"
        />
      </div>
      <div class="form-actions">
        <button type="submit" class="form-button form-button-submit">
          Создать
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";

export default {
  setup(_, { emit }) {
    const store = useStore();
    const form = ref({
      destination_city: "",
      destination_region: "",
      departure_city: "",
      departure_region: "",
      client_price_without_nds: null,
      client_price_with_nds: null,
    });

    const fields = [
      { label: "Город отправления", model: "departure_city", type: "text", required: true },
      { label: "Регион отправления", model: "departure_region", type: "text", required: true },
      { label: "Город назначения", model: "destination_city", type: "text", required: true },
      { label: "Регион назначения", model: "destination_region", type: "text", required: true },
      { label: "Цена клиента (без НДС)", model: "client_price_without_nds", type: "number", required: true },
      { label: "Цена клиента (с НДС)", model: "client_price_with_nds", type: "number", required: true },
    ];

    const submitForm = async () => {
      await store.dispatch("trade/sendCalculatorForm", form.value);
      emit("close");
    };

    return {
      form,
      fields,
      submitForm,
    };
  },
};
</script>

<style scoped>
.new-route-form {
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.form-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}

.form-container {
  display: flex;
  flex-direction: column;
}

.form-label {
  margin-bottom: 5px;
  font-size: 14px;
}

.form-input {
  margin-bottom: 15px;
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
}

.form-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.form-actions {
  display: flex;
  justify-content: space-between;
}

.form-button {
  padding: 8px 15px;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.form-button-submit {
  background-color: #28a745;
  color: #ffffff;
}

.form-button-submit:hover {
  background-color: #218838;
}

.form-button-cancel {
  background-color: #dc3545;
  color: #ffffff;
}

.form-button-cancel:hover {
  background-color: rgb(200, 35, 51);
}
</style>
